import { SAVE_FAQ } from './actionTypes'
import { FaqType } from './types'
import { ModelCategory } from '../../../types/faq/faq_model'

export const saveFaq = (categories: ModelCategory[]): FaqType => {
	return ({
		type: SAVE_FAQ,
		payload: categories
	})
}
